<template>
  <div id="NATService" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 ">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">N</span>AT Servicio</div>
        <div class="col-3 f26 t-r color-primary"></div>
      </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 t-c pt10 pb10">
      <i class="iconfont icon-NATwangguan color-primary f60"></i>
    </div>
    <div class="col-12" v-if="Object.keys(pageData).length === 0 || to_change">
      <div class="col-12">
        <div class="col-12 t-c pt10 pb10 lh22 f18 color-muted pl10 pr10">
          Configurar servicio NAT:
        </div>
        <div class="col-12 t-c pt10 pb10 pl10 pr10">
          <div class="col-12">
            <select v-model="selectedPackage" class="p10">
              <option v-for="plan in plan_list" :value="plan.id" :key="plan.id">{{ plan.plan_name }}</option>
            </select>
            <select v-model="selectedNumber" class="p10">
              <option v-for="number in numbers" :value="number" :key="number">{{ number }}</option>
            </select>
            <select v-model="paymentOption" class="p10">
              <option value="yearly">Año</option>
            </select>
          </div>
        </div>
        <div class="col-12 pt10 pb10 pl10 pr10 t-c-v" v-if="to_change == false">
          <div class="bg-color-primary r5 p10 color-white w30 t-c" @click="plan_select()">Confirmar</div>
        </div>
        <div class="col-12 pt10 pb10 pl10 pr10 t-c-v" v-else>
          <div class="bg-color-muted r5 p10 color-white col-6 t-c mr5" @click="toChange()">Vuelta</div>
          <div class="bg-color-primary r5 p10 color-white col-6 t-c ml5" @click="plan_select()">Confirmar</div>
        </div>
      </div> 
    </div>
    <div class="col-12" v-else>
      <div class="col-12 t-c pt10 lh22 f18 pl10 pr10 color-black">
        <i class="iconfont icon-NATwangguan color-primary"></i> {{ plan.plan_name }} 
        <i class="iconfont icon-add-circle color-success" @click="toChange(1)"></i>  
        <i class="iconfont icon-error color-danger" @click="plan_delete_confim()"></i>
      </div>
      <div class="col-12 t-c pt5 pb5 color-muted pl10 pr10 f14 mb30">
        Al servicio NAT le quedan <span class="color-success f18">{{ pageData.exp_day}}</span> días
      </div>
      <div class="col-12 pl10 pr10">
        <div class="col-12 lh40">
          <i class="iconfont icon-arrow-right-filling color-primary"></i> Información del servicio
        </div>
        <div class="col-12 bg-color-white bb1 lh40 r5 f14 mb5 pl10 pr10">
          <div class="col-6">Estado:</div>
          <div class="col-6 pr10 t-r">
            <span v-if="pageData.status == 1" class="color-success">Activo</span>
            <span v-else class="color-danger">Inactivo</span>
          </div>
        </div>
        <div class="col-12 bg-color-white bb1 lh40 r5 f14 mb5 pl10 pr10" v-if="pageData.server_ip">
          <div class="col-6">IP del servidor:</div>
          <div class="col-6 pr10 t-r">{{ pageData.server_ip }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 lh40 r5 f14 mb5 pl10 pr10" v-if="pageData.port">
          <div class="col-6">Puerto:</div>
          <div class="col-6 pr10 t-r">{{ pageData.port }}</div>
        </div>
        <div class="col-12 bg-color-white bb1 lh40 r5 f14 mb5 pl10 pr10" v-if="pageData.create_time">
          <div class="col-6">Fecha de creación:</div>
          <div class="col-6 pr10 t-r">{{ pageData.create_time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NATService',
  data () {
    return {
      appid: this.$route.query.appid,
      selectedPackage: '1',
      paymentOption: 'yearly',
      selectedNumber: '1',
      pageData: {},
      plan: {},
      plan_list: [],
      numbers: [1,2,3,4,5,6,7,8,9,10,11,12],
      to_change: false
    }
  },
  created: function () {
    this.get_nat_service();
  },
  methods: {
    //获取NAT服务信息
    get_nat_service(){
      var post_data = {};
      post_data.appid = this.appid;
      this.post(this.api_url + 'Tec/nat_service', post_data).then((res)=>{
        if(res.status == 1){
          if(res.data['nat_service']){
            this.pageData = res.data['nat_service'];
            this.plan = res.data['plan'];
          }
          this.plan_list = res.data['plan_list'] || [];
        }else{
          this.plan_list = res.data['plan_list'] || [];
          this.data_status = 2;
        }
      })
    },
    //选择套餐
    plan_select(){
      var post_data = {};
      post_data.appid = this.appid;
      post_data.plan_id = this.selectedPackage;
      post_data.number = this.selectedNumber;
      post_data.payment = this.paymentOption;
      this.post(this.api_url + 'Tec/nat_service_plan', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.to_change = false;
          this.get_nat_service();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //修改套餐
    toChange(){
      if(this.to_change == false){
        this.to_change = true;
      }else{
        this.to_change = false;
      }
    },
    //删除套餐确认
    plan_delete_confim(){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'Confirmar para eliminar este servicio NAT?',_this:this,focus:'',method:'plan_delete',arg1:''});
    },
    //删除套餐
    plan_delete(){
      var post_data = {};
      post_data.appid = this.appid;
      this.post(this.api_url + 'Tec/nat_service_delete', post_data).then((res)=>{
        if(res.status == 1){
          this.get_nat_service();
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Technician/NATService.vue